import React, { createContext, useContext, useEffect, useState } from "react";
import { api, LITURGY_HSL, MOOD_CLASS } from "@/lib/api";

const LiturgicalContext = createContext(null);

const ALL_MOOD_CLASSES = ["mood-celebratory", "mood-joyful", "mood-marian", "mood-ordinary", "mood-penitential", "mood-solemn"];

export const LiturgicalProvider = ({ children }) => {
    const [today, setToday] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/liturgical/today").then((r) => {
            setToday(r.data);
        }).catch(() => {
            setToday({ color: "green", mood: "ordinary", season: "Ordinary Time" });
        }).finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        if (!today) return;
        const root = document.documentElement;
        const hsl = LITURGY_HSL[today.color] || LITURGY_HSL.green;
        root.style.setProperty("--liturgy", hsl);
        // Clear any prior mood classes then apply the current one
        ALL_MOOD_CLASSES.forEach(c => document.body.classList.remove(c));
        document.body.classList.remove("sacred"); // legacy dark class
        const cls = MOOD_CLASS[today.mood] || MOOD_CLASS.ordinary;
        document.body.classList.add(cls);
    }, [today]);

    return (
        <LiturgicalContext.Provider value={{ today, loading }}>
            {children}
        </LiturgicalContext.Provider>
    );
};

export const useLiturgical = () => useContext(LiturgicalContext);
